import React from 'react';
import { Star } from 'lucide-react';
import { testimonials } from '../data/mockData';
import LightEffects from './LightEffects';

const Testimonials = () => {
  return (
    <section className="relative bg-black py-24 md:py-32">
      {/* Light Effects */}
      <LightEffects variant="intense" />
      <LightEffects variant="crossing" />
      
      <div className="container mx-auto px-[7.6923%]">
        {/* Section Header */}
        <div className="text-center mb-20">
          <h2 className="text-5xl md:text-6xl font-semibold text-white mb-6 tracking-tight">
            What Our Clients Say
          </h2>
          <div className="h-1 w-24 bg-blue-500 mx-auto mb-6"></div>
          <p className="text-xl text-white/70 max-w-3xl mx-auto leading-relaxed">
            Trusted by leading lighting professionals and venues worldwide
          </p>
        </div>

        {/* Testimonials Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 max-w-6xl mx-auto">
          {testimonials.map((testimonial) => (
            <div
              key={testimonial.id}
              className="group relative bg-gradient-to-br from-white/5 to-transparent border border-white/10 p-10 transition-all duration-500 hover:border-blue-500/50 hover:shadow-2xl hover:shadow-blue-500/20"
              style={{ borderRadius: '0px' }}
            >
              {/* Quote Mark */}
              <div className="absolute top-6 left-6 text-6xl text-blue-500/20 font-serif leading-none">
                "
              </div>

              {/* Rating */}
              <div className="flex gap-1 mb-6 relative z-10">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <Star key={i} size={18} className="text-blue-500 fill-blue-500" />
                ))}
              </div>

              {/* Quote */}
              <p className="text-base text-white/85 mb-8 leading-relaxed relative z-10 italic">
                {testimonial.quote}
              </p>

              {/* Author Info */}
              <div className="flex items-center gap-4 relative z-10">
                <img
                  src={testimonial.image}
                  alt={testimonial.name}
                  className="w-14 h-14 object-cover border-2 border-blue-500"
                  style={{ borderRadius: '0px' }}
                />
                <div>
                  <h4 className="text-lg font-semibold text-white">
                    {testimonial.name}
                  </h4>
                  <p className="text-sm text-white/60">
                    {testimonial.role}
                  </p>
                  <p className="text-sm text-blue-400">
                    {testimonial.company}
                  </p>
                </div>
              </div>

              {/* Hover Effect Line */}
              <div className="absolute bottom-0 left-0 w-0 h-1 bg-blue-500 transition-all duration-500 group-hover:w-full"></div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
